// web/src/lib/photoCategories.js
// What a photo is OF.
//
// Fixed, unlike lesson types. A barn names its own lesson types because jump
// heights and group sizes genuinely differ between barns; "injury" does not.
// A short shared vocabulary is also what makes the filter useful — categories
// everyone types differently stop being categories.
//
// Same Tailwind constraint as lessonTypes.js: classes are scanned out of source
// as literal strings, so every one has to be spelled out here rather than built
// at runtime.
//
// Keep in step with:
//   - the CHECK on horse_photos.category in migration 0016
//   - the CATEGORIES array in api/src/routes/horse-photos.ts

export const PHOTO_CATEGORIES = [
  { token: 'injury', label: 'Injury' },
  { token: 'progress', label: 'Progress' },
  { token: 'conformation', label: 'Conformation' },
  { token: 'feet', label: 'Feet & shoeing' },
  { token: 'tack', label: 'Tack & fit' },
  { token: 'show', label: 'Show' },
  { token: 'other', label: 'Other' },
];

const STYLES = {
  injury: 'bg-rose-100 text-rose-800',
  progress: 'bg-emerald-100 text-emerald-800',
  conformation: 'bg-indigo-100 text-indigo-800',
  feet: 'bg-amber-100 text-amber-800',
  tack: 'bg-violet-100 text-violet-800',
  show: 'bg-sky-100 text-sky-800',
  other: 'bg-slate-100 text-slate-700',
};

const FALLBACK = 'bg-slate-100 text-slate-700';

/** Chip classes for a category token. */
export function categoryClass(token) {
  return STYLES[token] ?? FALLBACK;
}

/** Human label. Unknown tokens render themselves rather than disappearing. */
export function categoryLabel(token) {
  if (!token) return 'Uncategorized';
  return PHOTO_CATEGORIES.find((c) => c.token === token)?.label ?? token;
}
